export const TabsContent = (props) => {
  const { tabsGallery, tabsContent } = props;

  return (
    <div className="tabs__panel-content">
      {tabsContent.map((item, idx) => {
        return (
          <div style={{ display: tabsGallery === idx ? 'block' : 'none' }} key={item.id}>
            {item.element}
          </div>
        );
      })}
    </div>
  );
};
